import { render, staticRenderFns } from "./OffersPage.vue?vue&type=template&id=f3e6aefa&scoped=true&"
import script from "./OffersPage.vue?vue&type=script&lang=js&"
export * from "./OffersPage.vue?vue&type=script&lang=js&"
import style0 from "./OffersPage.vue?vue&type=style&index=0&id=f3e6aefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e6aefa",
  null
  
)

export default component.exports